// manipulating percentages as strings instead of numbers to avoid floating point math issues

export const percentageInputFormatToStorageFormat = (str) => {
  if (isNaN(str) || !str) return '';
  let safeStr = '00'.concat(str);
  if (safeStr.indexOf('.') === -1) safeStr = safeStr.concat('.0');
  const substrings = safeStr.split('.');
  return substrings[0]
    .slice(0, substrings[0].length - 2)
    .concat('.', substrings[0].slice(substrings[0].length - 2), substrings[1]);
};

export const percentageStorageFormatToInputFormat = (value) => {
  if (isNaN(value) || !value) return '';
  const str = value.toString();
  let decimalLocation = str.indexOf('.');
  let safeStr;
  if (decimalLocation === -1) {
    safeStr = str.concat('.00');
  } else if (decimalLocation !== -1 && decimalLocation > str.length - 3) {
    safeStr = str.concat('00');
  } else if (decimalLocation !== -1 && decimalLocation > str.length - 2) {
    safeStr = str.concat('0');
  } else {
    safeStr = str;
  }
  decimalLocation = safeStr.indexOf('.');
  const newString = safeStr
    .slice(0, decimalLocation)
    .concat(
      safeStr.slice(Number(decimalLocation) + 1, Number(decimalLocation) + 3),
      '.',
      safeStr.slice(Number(decimalLocation) + 3)
    );
  return Number(newString).toString();
};
